<template>
    <div class="help-main" v-loading="dataLoading">
        <div v-for="(item, index) in helpContent" :key="index" class="help-content">
            <div class="page-group-title">{{ item.title }}</div>
            <div v-html="item.content" class="content m-t-4"></div>
        </div>
        <div v-if="!dataFlag" class="help-content">
            <el-empty description="没有相关数据"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            dataLoading: false,
            helpContent: [],
            dataFlag: true
        };
    },
    computed: {
        helpMenus() {
            return this.$store.state && this.$store.state.helpMenus;
        }
    },
    created() {
        if (!this.id && this.helpMenus) {
            this.goArticle();
        }
    },
    watch: {
        helpMenus: function () {
            if (!this.id) {
                this.goArticle();
            }
        }
    },
    mounted() {
        if (this.id) this.goArticle();
    },
    methods: {
        goArticle() {
            const { key } = this.$route.query;
            if (key) return this.getArticleKey(key);
            this.getArticle();
        },
        async getArticleKey(key) {
            this.helpContent = [];
            this.dataLoading = true;
            const response = await this.$request({
                url: '/faq/cp_faq/view/getByEntryKeyOnlyFirstLvl',
                params: {
                    faqKey: key
                },
                method: 'post'
            });
            const { msg, state, result } = response.data;
            this.dataLoading = false;
            if (!state) return this.$message.error(msg || '');
            if (!this.id) {
                this.$router.replace({
                    path: `/help/${result[0].secondMenuId}?key=${key}`
                });
            } else {
                this.helpContent = result || [];
                this.dataFlag = result.length >= 1;
            }
        },
        getArticle() {
            this.dataLoading = true;
            if (!this.id) {
                this.dataFlag = false;
                return (this.dataLoading = false);
            }
            this.$request({
                url: '/faq/cp_faq/view/getByMenuId',
                params: {
                    menuId: this.id
                },
                method: 'post'
            })
                .then(res => {
                    const { state, msg, result } = res.data;
                    if (state) {
                        this.helpContent = result || [];
                        this.dataFlag = result.length >= 1;
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.dataLoading = false;
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }
    }
};
</script>

<style lang="scss">
.help-main {
    position: relative;
    z-index: 12;
    background-color: $--color-white;

    .help-content {
        min-height: 100vh;
        padding: 40px;
    }

    .content {
        color: $-text-600;
        line-height: 26px;

        * {
            margin: initial;
            padding: revert;
            font-style: revert;
            box-sizing: inherit;
        }

        strong,
        .page-group-title {
            color: $-text-950;
            margin: 20px 0px 10px;
            display: block;
        }

        div,
        ul,
        ol {
            margin: 4px 0;
        }

        ul {
            padding-inline-start: 20px;

            li {
                list-style: initial;
                line-height: 35px;

                ul li {
                    list-style: circle;
                    color: $-text-600;
                }
            }
        }

        ol {
            padding-inline-start: 20px;

            li {
                list-style: decimal;
            }
        }

        img {
            max-width: 100%;
        }

        table {
            border-collapse: collapse;
            margin: 16px 0;

            td {
                border: 1px solid #ddd;
                padding: 0.4rem;
            }
        }
    }
}
</style>
